const NAME = "VACATIONS_PAGE";

export default NAME;
